import { requests } from '.'

export const SaasService = {
  getLocationWalletBalance: (companyId: string) =>
    requests().get(
      `/saas_service/company/${companyId}/location-wallet-balances`
    ),
}
